<template>
<div class="upload-image">
  <template v-for="(item,index) in file_list">
    <el-popover
      placement="top"
      width="90"
      trigger="hover">
      <div style="display: flex;flex-direction: column;">
        <div>
          <el-button size="mini" @click="prv(index)" icon="el-icon-search" circle></el-button>
          <el-button size="mini" @click="uploadFile(index)" type="primary" icon="el-icon-edit" circle></el-button>
          <el-button size="mini" @click="del(index)" type="danger" icon="el-icon-delete" circle></el-button>
        </div>
        <div v-if="get_type(item.file)==='img'" style="margin-top: 5px">
          <el-input v-model="item.page" @change="elInput(item,index)" placeholder="小程序跳转连接" autocomplete="off"></el-input>
        </div>
      </div>
      <el-image
        slot="reference"
        v-if="get_type(item.file)==='img'"
        :key="index"
        class="upload-el-img"
        :src="url(item.file)"
        fit="cover"></el-image>
      <video slot="reference" v-if="get_type(item.file)==='video'" class="upload-el-img" :src="url(item.file)" />
      <el-avatar
        v-if="get_type(item.file)==='other'"
        slot="reference"
        :key="index"
        class="upload-el-img"
        icon="el-icon-paperclip"></el-avatar>
    </el-popover>

  </template>
  <el-button class="upload-btn" @click="uploadFile(null)" icon="el-icon-upload"></el-button>
</div>
</template>

<script>
import xhHelp from "../xhHelp";

export default {
  name: "UploadImage",
  props:{
    files:String|Array,
  },
  model: {
    prop: "files", // 定义传递给v-model的那个变量，绑定到哪个属性值上               (默认值value)
    event: "success", // event:什么时候触发v-model行为(让父组件能获取到值)    (默认值input)
  },
  data(){
    var image_types=['png','jpg','jpeg','gif'];
    var video_types=['mp4','mov'];
    var get_type=function (file) {
      if(!file){
        return 'other';
      }
      let file_arr=file.split('.')
      let file_type=file_arr[file_arr.length-1];
      if(image_types.includes(file_type)){
        return 'img'
      }else if(video_types.includes(file_type)){
        return 'video'
      }else {
        return 'other';
      }
    }
    return {
      url:xhHelp.hostUrl,
      file_list:[],
      get_type:get_type,
    }
  },
  watch:{
    files:{
      deep:true,
      immediate:true,
      handler(n){
        if(typeof this.files==='string'){
          this.file_list= []
        }else {
          this.file_list= JSON.parse(JSON.stringify(this.files));
        }
      }
    },
    // file_list:{
    //   deep:true,
    //   immediate:true,
    //   handler(n){
    //     this.$emit("success",n);
    //   }
    // }
  },
  methods:{
    uploadFile(index=null){
      var that=this;
      xhHelp.uploadFileCustom('uploadFile',path=>{
        let file_list=JSON.parse(JSON.stringify(that.file_list));
        if(index===null){
          file_list.push({
            file:path,
            page:""
          })
        }else {
          file_list[index]={
            ...file_list[index],
            file:path,
          };
        }
        that.file_list=file_list;
        that.$emit("success",that.file_list);
      })
    },
    del(index){
      var that=this;
      that.file_list.splice(index,1);
      that.$emit("success",that.file_list);
    },
    prv(index){
      if(this.get_type(this.file_list[index].file)==='img'){
        this.$alert('<img style="max-width: 500px;max-height: 500px;" src="'+this.url(this.file_list[index].file)+'" />', '预览', {
          dangerouslyUseHTMLString: true
        });
      }else if(this.get_type(this.file_list[index].file)==='img'){
        this.$alert('<video style="max-width: 500px;max-height: 500px;" src="'+this.url(this.file_list[index].file)+'" />', '预览', {
          dangerouslyUseHTMLString: true
        });
      }else {
        window.open(this.url(this.file_list[index].file))
      }

    },
    elInput(item,index){
      this.file_list[index]=item;
      this.$emit("success",this.file_list);
    }
  }
}
</script>

<style lang="scss" scoped>
.upload-image{
  width: 100%;
  display: flex;
  //flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
}
.upload-btn{
  width: 60px;
  height: 60px;
  text-align: center;
  margin: 5px;
  border-radius: 10px;
  background-color: #e8e8e8
}
.upload-el-img-col{
  width: 70px;
  //height: 60px;
}
.upload-el-img{
  width: 60px;
  height: 60px;
  margin: 5px;
  border-radius: 10px;
  overflow: hidden;
  line-height: 60px;
}
.el-button--primary, .el-button--danger {
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/App/Card/components/UploadImage.vue